module.exports = __webpack_public_path__ + "img/pie-chart-03.beb79dd5.svg";